// extracted by mini-css-extract-plugin
module.exports = {"font14":"SliderEmployeeInfo_font14__2P5HD","scrl":"SliderEmployeeInfo_scrl__1qYZb"};